module.exports = __webpack_public_path__ + "img/CHECK.e7686165.svg";